<template>
  <div>
    <h1>{{ $route.meta.title }}</h1>
    <div class="trello-container">
      <div class="demande-body" v-if="card">
        <!-- Demande -->
        <section class="demande-form">
          <h4>Récapitulatif</h4>
          <div class="form-group">
            <label>Créée par :</label>
            <div class="form-control d-flex align-items-center">
              <div class="initiales">{{card.creator && card.creator.initiales}}</div>
              <div>{{card.creator && card.creator.fullName}}</div>
            </div>
          </div>
          <div class="form-group">
            <label>Le :</label>
            <div class="form-control">{{ card.creationDateTime }}</div>
          </div>
          <div class="form-group">
            <label>Projet / Périmètre :</label>
            <div class="form-control">{{ boardName }}</div>
          </div>
          <div class="form-group" v-if="card.custom && card.initialDesc.projet != ''">
            <label>Projet concerné :</label>
            <div class="form-control"><span class="label label-generique">{{ card.initialDesc.projet }}</span></div>
          </div>
          <div class="form-group">
            <label>Type de demande :</label>
            <div class="form-control"><span :class="card.demandeType ? getColor(card.demandeType.color) : ''">{{ card.demandeType && card.demandeType.name }}</span></div>
          </div>
          <div class="form-group" v-if="card.custom">
            <label>Priorité initiale :</label>
            <div class="form-control">
              <span :class="card.initialDesc.priorite ? getColor(card.initialDesc.priorite.color) : ''">{{ card.initialDesc.priorite && card.initialDesc.priorite.label }}</span>
            </div>
          </div>
          <div class="form-group">
            <label>Priorité :</label>
            <div class="form-control">
              <span :class="card.priorite ? getColor(card.priorite.color) : ''">{{ card.priorite && card.priorite.label }}</span>
            </div>
          </div>
          <div class="form-group">
            <label>Date souhaitée :</label>
            <input type="date" v-model="card.initialDesc.dateSouhaitee" class="form-control" disabled />
          </div>
          <div class="form-group">
            <label>Date ajustée :</label>
            <input type="date" v-model="card.due" class="form-control" disabled />
          </div>
          <hr />
          <!-- Description -->
          <div class="row">
            <div class="form-group">
              <label>Titre :</label>
              <input type="text" class="form-control" v-model="card.name" readonly />
            </div>
          </div>
          <div class="row">
            <div class="form-group">
              <label>Description :</label>
              <textarea class="form-control" v-model="card.desc" readonly></textarea>
            </div>
          </div>
          <div class="row">
            <div class="form-group">
              <label>Listes de tâches :</label>
              <div v-for="checklist of card.checklists" :key="checklist.id" class="mt-2">
                <label>{{checklist.name}} :</label>
                <br />
                <div v-for="item of checklist.checkItems" :key="item.id">
                  <input type="checkbox" :disabled="true" :checked="item.state == 'complete'" />
                  {{item.name}}
                </div>
              </div>
            </div>
          </div>
          <!-- Screenshot -->
          <div class="row">
            <div class="form-group">
              <div class="d-flex justify-content-between">
                <span>Pages écran :</span>
                <label class="add-attachment-input">
                  <div class="input-btn"><font-awesome-icon class="icon" icon="plus"></font-awesome-icon></div>
                  <input type="file" @change="uploadFile" />
                </label>
              </div>
              <div class="demande-screen-container">
                <div v-for="(attachment, index) in attachmentsEncoded" :key="index" class="demande-screen-parent">
                  <!-- Image -->
                  <a :href="attachment.url" class="demande-screen-icone" target="_blank" v-if="attachment.type == 'image'">
                    <img :src="attachment.url" />
                  </a>
                  <!-- Excel -->
                  <a :href="attachment.url" class="demande-screen-icone" download v-if="attachment.type == 'excel'"><img src="@/assets/icones/excel.png" /></a>
                  <!-- PDF -->
                  <a :href="attachment.url" class="demande-screen-icone" download v-if="attachment.type == 'pdf'"><img src="@/assets/icones/pdf.png" /></a>
                  <!-- TXT -->
                  <a :href="attachment.url" class="demande-screen-icone" download v-if="attachment.type == 'txt'"><img src="@/assets/icones/txt.jpeg" /></a>
                  <!-- Word -->
                  <a :href="attachment.url" class="demande-screen-icone" download v-if="attachment.type == 'word'"><img src="@/assets/icones/word.png" /></a>
                  <!-- PPT -->
                  <a :href="attachment.url" class="demande-screen-icone" download v-if="attachment.type == 'ppt'"><img src="@/assets/icones/ppt.png" /></a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Réponse -->
        <section class="response-form">
          <h4>Requalification de la demande</h4>
          <!-- Première ligne -->
          <div class="form-group">
            <label>Type de demande :</label>
            <select class="form-control" v-model="demandeTypeRequalif" :disabled="!isAdmin">
              <option v-for="_td in typeDemande" :value="_td.color" :key="_td.color">{{ _td.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Priorité :</label>
            <select class="form-control" v-model="demandePrioriteRequalif" :disabled="!isAdmin">
              <option v-for="_td in typePriorite" :value="_td.color" :key="_td.color">{{ _td.label }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Date d'échéance :</label>
            <input type="date" v-model="card.due" class="form-control" :disabled="!isAdmin" />
          </div>
          <div class="form-group">
            <label>Affectation :</label>
            <div class="d-flex mt-2 mb-2">
              <div v-for="idTrello in card.idMembers" :key="idTrello" class="d-flex align-items-center mx-3">
                <div class="initiales">{{getUserFromIdTrello(idTrello).initials}}</div>
                <div>{{getUserFromIdTrello(idTrello).firstName + " " + getUserFromIdTrello(idTrello).name}}</div>
              </div>
            </div>
            <select class="form-control" v-model="card.idMembers" multiple :disabled="!isAdmin">
              <option v-for="u in userAdmin" :value="u.idTrello" :key="u.idTrello" class="d-flex">
                {{ u.firstName }} {{ u.name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>Etat d'avancement :</label>
            <select class="form-control" v-model="card.idList" :disabled="!isAdmin">
              <option v-for="l in lists" :value="l.id" :key="l.id">{{ l.name }}</option>
            </select>
          </div>
          <!-- Sauvegarde -->
          <!-- Sauvegarde -->
          <div v-if="isAdmin" class="form-group d-flex justify-content-center align-items-center mt-4">
            <button class="button button-primary" v-on:click="execUpdateCard()" :disabled="!isAdmin">Sauvegarder</button>
          </div>
        </section>
        <!-- Etat d'avancement' -->
        <section class="process-form">
          <h4>Etat d'avancement</h4>
          <!-- Première ligne -->
          <div>
            <div class="form-group mb-3">
              <label>Statut actuel:</label>
              <div class="form-control">{{ progression.textState }}</div>
            </div>
            <ProgressBar borderColor="#CCC" :percentList="[{color: '#A7C13C', percent: calcPercent(progression.cardState, progression.maxState)}]" />
            <br />
            Historique récent:
            <ul class="form-group mt-3">
              <li v-for="(action, i) of lastActionsFormatted" :key="i">
                {{action}}
              </li>
            </ul>
          </div>
        </section>
        <!-- Commentaires -->
        <section class="tchat-form" ref="tchatContainer">
          <h4>Tchat</h4>
          <div class="tchat-container">
            <div>
              <label>Nouveau message : </label>
              <div class="postNewComment" ref="postNewComment">
                <div class="inputBlock">
                  <textarea class="form-control" v-model="messageToSend"></textarea>
                </div>
                <div class="buttonBlock">
                  <button class="button button-primary" v-on:click="createComment()">Envoyer</button>
                </div>
              </div>
              <br />
            </div>
            <Tchat class="msg-container" :style="{top: 'calc(' + tchatTop + 'px + 2rem)'}" :messages="comments" :idUser="$store.state.self.userSdcGuid"></Tchat>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getCardInfos,
    getBoards,
    getLabels,
    updateCard,
    getLists,
    createComment,
    getAttachment,
    addAttachment,
  } from "@/utils/trello"
  import { formatDate, formatDateTime, calcPercent } from "@/utils";
  import { getUserInitials } from "@/utils/user";
  import { ParseComments, CreateComment, TransformAttachment, GetObjectType, ActionToText } from "@/utils/trelloContentHelper";
  import { convertTrelloCommentsToTchat } from "@/helpers/trelloCustomMessageToTchatConverter.js";
  import Tchat from "@/components/Tchat";
  import ProgressBar from "@/components/ProgressBar";

  export default {
    name: "TicketDetail",
    components: {
      Tchat,
      ProgressBar
    },
    data() {
      return {
        mounted: false,
        cardId: "",
        card: null,
        boardName: "",
        boards: [],
        lists: [],
        labels: [],
        typeDemande: this.$store.state.trelloConfig.typeDemandeConfig,
        typePriorite: this.$store.state.trelloConfig.prioriteConfig,
        userAdmin: this.$store.state.trelloConfig.userConfig,
        demandeTypeRequalif: "",
        demandePrioriteRequalif: "",
        progression: {
          cardState: 0,
          maxState: 0,
          textState: "",
        },
        // Commentaires = tchat
        comments: [],
        messageToSend: "",

        // Pièces jointes
        attachmentsEncoded: [],
      }
    },
    mounted() {
      this.cardId = this.$route.query.id;
      this.initDatas();
    },
    watch: {
      $route() {
        this.cardId = this.$route.query.id;
      }
    },
    methods: {
      getUserFromIdTrello(idTrello) {
        return this.$store.state.trelloConfig.userConfig.find(u => u.idTrello == idTrello);
      },
      calcPercent(val, total) {
        return calcPercent(val, total)
      },
      // Initialisation des données
      initDatas() {
        getCardInfos(this.cardId).then(res => {
          if (res.actions.length > 10) {
            // @TODO -> Afficher que les éléments ne seront pas pris en compte et tronqués
          }
          this.card = res;

          getLabels(this.card.idBoard).then(r => {
            this.labels = r;
          })
          // On récupère toutes les listes du tableau de cette carte
          // => On affiche l'état d'avancement 
          getLists(this.card.idBoard).then(lists => {
            // On met à plat la liste de listes du board
            const boardLists = Object.values(this.$store.state.trelloConfig.boardConfig[this.card.idBoard]).reduce((acc, listList) => {
              acc = [...acc, ...listList]
              return acc;
            }, [])
            // On ne garde que les listes configurées
            this.lists = lists.filter(l => boardLists.indexOf(l.id) != -1);

            // Position de la liste dans le tableau
            var _currentListPosition = this.lists.findIndex(l => l.id == this.card.idList);
            var _currentList = this.lists.find(l => l.id == this.card.idList);

          //  this.progression.maxState = this.lists.length - 1;
          //  this.progression.cardState = _currentListPosition;
          //  this.progression.textState = _currentList.name;

            this.progression.maxState = 4
            this.progression.cardState = ["todo", "doing", "test", "done"].indexOf(this.card.listType) + 1;
            this.progression.textState = _currentList.name;
          })

          // On récupère la date de création
          this.card.creationDateTime = formatDateTime(new Date(this.card.actions.find(a => a.type == "createCard").date), true);
          //this.card.creationDate = this.card.actions.find(a => a.type == "createCard").date.slice(0, 10);
          //this.card.creationHour = this.card.actions.find(a => a.type == "createCard").date.slice(11, 16);

          // On récupère les tableaux pour afficher le "périmètre"
          getBoards().then(b => {
            this.boards = b;
            this.boardName = b.find(e => e.id == this.card.idBoard).name;
          })

          // On initialise les valeurs de requalification aux valeurs actuelles
          this.demandeTypeRequalif = this.card.demandeType ? this.card.demandeType.color : "";
          this.demandePrioriteRequalif = this.card.priorite ? this.card.priorite.color : "";

          // On réduit la longueur de la date de fin
          this.card.due = this.card.due != undefined ? this.card.due.slice(0,10): "";

          // On gère les commentaires
          this.comments = convertTrelloCommentsToTchat(ParseComments(this.card.actions.filter(a => a.type == "commentCard")));

          this.attachmentsEncoded = [];

          // On récupère les pièces jointes
          this.card.attachments.forEach(a => {
            if (a.isUpload) {
              getAttachment(a.url)
                .then(res => {
                  var _doc = TransformAttachment(a.mimeType, res);
                  this.attachmentsEncoded.push(_doc);
                });
            } else {
              this.attachmentsEncoded.push({ url: a.url, type: GetObjectType(a.mimeType) })
            }
          });
          this.$nextTick(() => {
            this.mounted = true;
          })
        })
      },

      // Génération de la classe selon la couleur
      getColor(color) {
        return "label label-" + color;
      },

      // On récupère les labels de la carte
      updateLabels() {
        var _type = this.labels.find(l => l.color == this.demandeTypeRequalif);
        var _priorite = this.labels.find(l => l.color == this.demandePrioriteRequalif);

        var returnLabels = [];
        if (_type) returnLabels.push(_type.id);
        if (_priorite) returnLabels.push(_priorite.id);

        if (returnLabels.length == 0) return "";
        return returnLabels;
      },

      // On met à jour la carte
      execUpdateCard() {
        var _desc = this.card.desc;

        // Vérification sur le format (custom ou standard)
        if (this.card.custom) {
          let initialDesc = Object.assign({}, this.card.initialDesc);
          if (this.card.initialDesc.priorite)
            initialDesc.priorite = initialDesc.priorite.priorite;
          _desc = JSON.stringify(initialDesc);
        };

        updateCard(
          this.card,
          this.card.name,
          _desc,
          this.card.due,
          this.card.idList,
          JSON.stringify(this.updateLabels()),
          JSON.stringify(this.card.idMembers),
        ).then(r => {
          this.initDatas();
        });
      },

      // Création d'un commentaire
      createComment() {
        let fullName = this.$store.state.self.firstname + " " + this.$store.state.self.name;

        // On passe tous les paramètres pour construire le commentaire
        var _comment = CreateComment(
          this.$store.state.self.userSdcGuid,
          fullName,
          getUserInitials(fullName),
          this.messageToSend);

        // Envoi du commentaire
        createComment(this.card, _comment).then(r => {
          this.messageToSend = ""; // On vide le message à envoyer, tout de même
          this.initDatas();
        })
      },
      // Envoie une nouvelle PJ
      uploadFile(e) {
        const file = e.target.files.length ? e.target.files[0] : null
        if (file) {
          addAttachment(this.card.id, file, file.type).then(() => {
            this.initDatas();
          })
          e.target.value = "";
        }
      }
    },
    computed: {
      tchatTop() {
        if (!this.mounted || !this.card) return 0;
        const container = this.$refs.tchatContainer;
        const sendInput = this.$refs.postNewComment;
        if (container && sendInput) {
          const rectSendInput = sendInput.getBoundingClientRect()
          const rectContainer = container.getBoundingClientRect()
          const res = rectSendInput.top - rectContainer.top + rectSendInput.height;
          return res;
        }
        return 0;
      },
      lastActionsFormatted() {
        return this.card.actions.slice(0, 5).map(a => ActionToText(a));
      },
      isAdmin() {
        return this.userAdmin.find(u => u.id == this.$store.state.self.userSdcGuid) ? true : false;
      }
    }
  }
</script>

<style scoped>
  .trello-container {
    
  }

  .demande-container {
    padding: 1rem;
    border-radius: 12px;
    background-color: white;
    box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.4);
    overflow-x: hidden;
  }

    .demande-container .heading {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #BEBEBE;
    }

      .demande-container .heading > h3 {
          font-size: 1.50rem;
      }

    h4 {
      font-size: 1.2rem;
    }

    .form-group {
        margin-top: 0.7rem;
    }

    .demande-body {
      display: grid;
      grid-template-areas: "demande response tchat"
                            "demande process tchat";
      grid-template-columns: repeat(3, 1fr);
      column-gap: 24px;
      row-gap: 24px;
    }

      .demande-body > section {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        background-color: white;
        border-radius: 12px;
        box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.4);
        padding: 0.5rem 1rem;
      }

        .demande-body > section h4 {
          padding-bottom: 0.3rem;
          border-bottom: 2px solid #EEE;
        }

  .demande-form {
    padding-right: 10px;
    border-right: solid 1px rgb(190, 190, 190);
    grid-area: demande;
  }

  .tchat-form {
    padding-right: 10px;
    border-top: solid 1px rgb(190, 190, 190);
    grid-area: tchat;
    position: relative;
  }

  .response-form {
    padding-left: 10px;
    padding-right: 10px;
    border-right: solid 1px rgb(190, 190, 190);
    grid-area: response;
  }

  .process-form {
    padding-left: 10px;
    padding-right: 10px;
    grid-area: process;
  }


  /*.demande-body > .div*/
  .priorityBadge {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: black;
    margin: auto;
  }

    .priorityBadge.priority-0 {
      background-color: transparent;
      border: 1px solid #CCC;
    }

    .priorityBadge.priority-1 {
      background-color: rgb(237, 215, 71);
    }

    .priorityBadge.priority-2 {
      background-color: rgb(242, 162, 64);
    }

    .priorityBadge.priority-3 {
      background-color: rgb(218, 100, 79);
    }

  .badges .priority-badge {
    width: 100%;
    padding: 0.5rem 0.7rem;
    color: white;
    font-size: 0.8rem;
    border-radius: 8px;
    display: flex;
    align-items: center;
  }

    .badges .priority-badge:nth-child(1) {
      background-color: rgb(237, 215, 71);
    }

    .badges .priority-badge:nth-child(2) {
      background-color: rgb(242, 162, 64);
    }

    .badges .priority-badge:nth-child(3) {
      background-color: rgb(218, 100, 79);
    }

  .board-box .progress-bar {
    display: grid;
    justify-content: start;
    width: 100%;
    height: 16px;
    overflow: hidden;
    background-color: white;
    border: 1px solid #A7C13C;
    border-radius: 12px;
    margin-bottom: 15px;
    margin-top: 8px;
  }

    .board-box .progress-bar div:nth-child(1) {
      background-color: #A7C13C;
    }

    .board-box .progress-bar div:nth-child(2) {
      background-color: rgb(242, 162, 64);
    }

    .row {
        margin-bottom: 5px;
    }

  .postNewComment {
    display: flex;
  }

    .postNewComment > div.inputBlock {
      flex-grow: 1;
    }

      .postNewComment > div.inputBlock > textarea {
        resize: none;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

    .postNewComment > div.buttonBlock button {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      height: 100%;
    }



  .demande-screen-container {
      display: flex;
      flex-wrap: wrap;
      column-gap: 5px;
      row-gap: 5px;
      justify-content: space-around;
  }

    .demande-screen-parent {
      width: 30%;
      height: 64px;
    }

  .demande-screen-icone {
      display: block;
      height: 100%;
      text-align: center;
  }

  .demande-screen-icone > img {
      height: 100%;
      width: auto;
  }

  .initiales {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #A7C13C;
    border-radius: 50%;
    font-weight: bold;
    color: white;
    margin-right: 0.5rem;
  }

  .msg-container {
    position: absolute;
    bottom: 0.5rem;
    left: 1rem;
    right: 1rem;
    top: 50%;
    overflow-y: scroll;
  }

  .add-attachment-input .input-btn {
    aspect-ratio: 1/1;
    border: 1px solid #CCC;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1;
    padding: 0.3rem;
    transition: all ease 230ms;
  }

  .add-attachment-input .input-btn:hover {
      cursor: pointer;
      background-color: #A7C13C;
      color: white;
  }
  .add-attachment-input .input-btn .icon {
    font-weight: 100;
  }

  .add-attachment-input input {
      display: none;
  }

</style>



// WEBPACK FOOTER //
// src/pages/GestionProjet/TicketDetail.vue